<template>
  <ModalGlobal
    v-if="show"
    :id="modalId"
    :class="modalClass"
    @close-modal="$emit('close-modal')"
  >
    <template #dialogHeadImg>
      <span class="material-icons promotion-modal-icon">redeem</span>
    </template>

    <template #dialogHeading>
      {{ $t("messages.promotion_details_title") }}
    </template>

    <template #dialogDescription>
      <span class="block text-center">
        {{ message }}
      </span>
    </template>

    <button
      @click.prevent="$emit('close-modal')"
      type="button"
      class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-yellow-photo cursor-pointer font-semibold mx-auto"
    >
      {{ $t("gallery.vd.close") }}
    </button>
  </ModalGlobal>
</template>

<script>
export default {
  name: "PromotionDetailsModal",
  props: {
    /** Controls whether the reusable promotion details modal is rendered. */
    show: {
      type: Boolean,
      default: false,
    },
    /** DOM id assigned to ModalGlobal so each flow keeps its current selectors. */
    modalId: {
      type: String,
      required: true,
    },
    /** CSS classes applied to ModalGlobal for the current payment or cart context. */
    modalClass: {
      type: String,
      default: "modalPromotionDetails superimpose",
    },
    /** Already translated modal body text calculated by the parent flow. */
    message: {
      type: String,
      default: "",
    },
  },
};
</script>
